<template>
<div >
<h4><strong>LISTINO PREZZO DI ACQUISTO E VENDITA PRODOTTO</strong></h4>
<product-info class="mt-1" v-bind:productId="product.productId"></product-info>   
<div class="mb-2 mt-2">
  <button class="btn btn-outline-info"  @click="showStockHistory=true"><strong>LISTA VARIANTI GIA' ACQUISTATE</strong></button>
</div>
<product-stock-history v-if="showStockHistory" @close="showStockHistory=false" v-bind:productId="product.productId"></product-stock-history>


<button type="button" @click="modal.show=true" class="btn btn-info ml-1" data-toggle="modal" data-target="#modalPricing">
  <i style="color:beige" class="fas fa-calculator mr-2" aria-hidden="true"></i>
  INSERIMENTO PREZZO SCONTO E IVA
</button>

<!-- MODAL PRICING -->
<modal-pricing v-if="modal.show" v-bind:props="modal"  @close="closeModalPricing()" @update="setPriceList"></modal-pricing>

<div class="table-responsive-sm mt-1">              
<form  v-on:submit.prevent="submit()" >
<table class="table table-bordered table-sm" id="priceDetail">
    <thead class="thead-light">
    <tr>
        
        <th 
        class ="text-center"
         v-bind:style="{ color: index > 0 ? 'black':'blue', backgroundColor : index > 0 ? '#9ACD32':'' }"
         v-for="(key,index) in cols" :key="index">
        
        <span v-bind:style="{ color :  key !='Listino' ? 'black' : 'blue' }">{{key.toUpperCase()}}</span>
        </th>
    </tr>
    </thead>
    <tbody>
      <tr v-for="(entry, index1) in items" :key="index1">
        <td v-for="(key,index2) in cols" :key="index2" >
            
            <div v-if="key!='Listino'">

                <input min="0.01" step="0.01"  required  v-model = "entry[key]" class="form-control inputClass" v-bind:ref="entry['Listino'] +  index2" v-bind:id="entry['Listino'] + '|' + index2 "  v-bind:name="entry['Listino'] + '|' + index2 " type="number" placeholder="" :disabled="key=='Listino'">

            </div>

            <div v-else >
               
              <div  v-if="entry['Listino']=='acquisto'">
                    
                  
                 <span>ACQUISTO €</span> 

                                      
             </div>  

                <div v-else>
          
                  <span>VENDITA €</span> 
                    
                </div>

                 
                
                
          </div>
          
           

        </td>
      </tr>
    </tbody>
</table>
<div class="row">
  <div class="col">
  <span v-if="discountsList" style="font-size: 20px;" class="badge badge-light float-right">Sconto acquisto {{discountsList}}</span>
  </div>
</div>
  

  <label-price-list v-if="label" @update="setLabelData" v-bind:product="product"></label-price-list>
  <alert-box class="mt-1 mb-1" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>
  <button  type="submit" class="btn btn-primary float-right">
      
    <i class="fas fa-save mr-2" aria-hidden="true"></i>
      REGISTRA</button>


</form>
  
  <button style="background-color:#66CC66" @click="label=!label"  class="btn btn-sm mb-1">
      
    <i class="far fa-edit mr-2" aria-hidden="true"></i>
    PREZZO/SCONTO ETICHETTA
    <i class="fas fa-tags ml-2" aria-hidden="true"></i>
    
    </button>
    


 </div>
</div> 
</template>

<script>
import api                   from '@/api'
import alertBox              from '@/components/common/AlertBox.vue';
import productInfo           from '@/components/product/ProductInfo.vue';
import productStockHistory   from '@/components/backOffice/ready/ProductStockHistory.vue'
import labelPriceList        from '@/components/backOffice/ready/LabelPriceList.vue'
import ModalPricing          from '@/components/backOffice/ready/ModalPricing.vue';
import { mapGetters }       from 'vuex';

export default {
  
  components: {alertBox,productInfo,labelPriceList,productStockHistory,ModalPricing},  
  props: ['product'],
  
  data () {
  
    return {
     modal      : { 'show' : false,'prices':{'vat': this.product.vat},'discounts':[]}, 
    
     cols       : [],
     items      : [],
     barcodes   : [], 
     spinner    : false,
     labels     : [],
     label      : false,
    
      

     msg     : {
       title : '',
       body  : '',
       type  : 0
     },
    
     vat      : 0,
     showStockHistory : false,
     discounts : [],
     discountsList : ''
    
    

    }
  },
  computed: 
    {     
     ...mapGetters(['company']) 
      
    },
          
  mounted()
    {
      
    },
  created()
  {
     
   this.getData(this.product.productId)
  
  },

  methods: 
  {
    closeModalPricing()
    {
      
      this.modal.show = false
      
    },
    setPriceList(prices,discounts)
    {
      
      $('#modalPricing').modal('hide')
      this.modal.show      = false      
      this.modal.prices    = prices
      this.modal.discounts = discounts
      this.discounts       = discounts
      this.vat             = prices.vat
      this.setDiscountsList()
      
      this.setDataGrid()

    },

    setDiscountsList()
    {
      let list = []
      this.discounts.forEach(item =>{
        list.push(item.discount)
      })
      this.discountsList =  list.join(' + ')
      
    },
    setLabelData(items)
    {
       this.labels = items
      
    },
    submit() 
      {
        
        this.updateItems()
            
      },  

    createItems(priceList)
      {
      
        this.vat     = this.company.vat
        this.cols    = []
        this.items   = []
        
        var cols     = this.product.sizes

        this.cols.push('Listino')  
        cols.forEach(item =>
        {
          this.cols.push(item.size)
        })
      
        var obj = {'Listino':'acquisto'}

        cols.forEach(item =>
        {
          obj[item.size] = ''; 
          priceList.forEach(col=>{
            if(col.size_list == item.size)
            {
              obj[item.size] = col.price; 
            }
          })
        })

        this.items.push(obj)

        obj = {'Listino':'vendita'}
        
        cols.forEach(item =>
        {        
          obj[item.size] = ''; 
           priceList.forEach(col=>{
            if(col.size_list == item.size)
            {
              obj[item.size] = col.sell_price; 
            }
          })
        })
         
        this.items.push(obj)
       


      },
      setDataGrid()
      {
        let costPrice = this.modal.prices.price1
        let retailPrice = this.modal.prices.price2

        this.cols.forEach(col =>
          {              
            if (col != 'Listino')
            {
              this.items[0][col] = parseFloat(costPrice).toFixed(2)   
              this.items[1][col] = parseFloat(retailPrice).toFixed(2)   
            }    
          })
        
      },


      updateItems()
      {
        
        this.barcodes = this.product.barcodes

        const updateArr = (key,value,priceList) =>
        {
          this.barcodes.forEach(item =>
          {
            // ACQUISTO
            if(priceList == 'acquisto')
            {
              if(item.size == key)
              {
                item.costPrice      = value
                item.vat            = this.vat
               
              }
            }

            // VENDITA
            if(priceList == 'vendita')
            {
              if(item.size == key)
              {
                item.retailPrice = value
              }
            }

          })
        }
        this.items.forEach(e =>{
          var priceList = e.Listino
                      
          Object.entries(e).forEach(item => {
                      let key   = item[0]
                      let value = item[1]
                      //use key and value here
                      if (key!='Listino')
                      {
                        updateArr(key,value,priceList)
                        
                      }
          })
        })
      
      

      this.$emit('update',this.barcodes,this.labels,this.discounts)

     
      },


 async getData(productId)
      {
        var data = {'productId' : productId}  
        var sp   = {'sp':'spProductStockHistory'}
        var json = Object.assign(data, sp)  
        


        await api.post(json).then(res => {
          if(res.status==200)
            {
            
             this.createItems(res.data.recordsets[0])

             this.modal.show = true
   
                  this.$nextTick()
                  .then(() => {
                          $('#modalPricing').modal('show')
                  })


                 
            }
            else if(res.status==500)
            {
              console.log(res.data)

            } 
            else
            {
              console.log('Network Error.')                  
            } 
        }).catch(err => 
        {
          console.log(err.message)    
        }).finally(() => {
          this.spinner = false
        });


        

  
      },
     

      
      
  }
  
}
</script>

<style scoped>
.pointer{
  cursor: pointer;
}
.inputClass{
  font-weight       : bold;
}

h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 18px;
  color        :#006600;
}
.btn-link{
  font-family  : 'Roboto Condensed';
  font-size    : 12px;
}
.fa-calculator{
  color:darkcyan;
}

.fa-clone
{
  color:darkgreen;;
}
</style>